import axios from 'axios';
import { toast } from 'react-toastify';
import { history } from './../index';

if (process.env.NODE_ENV !== 'production')
    axios.defaults.baseURL = 'https://localhost:44353/api';
else
    axios.defaults.baseURL = 'https://api.easycreditcheck.ch/api';

axios.interceptors.request.use((config) => {
    const token = window.localStorage.getItem('crifJwt');

    if (token)
        config.headers.Authorization = `Bearer ${token}`;

    return config;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(undefined, error => {

    if (error.message === 'Network Error' && !error.response) {
        toast.error('Network error');
    }

    const { status, data, config } = error.response;

    if (status === 404)
        history.push('/notfound');

    if (status === 400) {
        if (config.method === 'get' && data.errors.hasOwnProperty('id'))
            history.push('/notfound');

        if (config.method === 'post') {
            toast.error(error.response.data.errors.error, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                progress: undefined,
            });
        }
    }

    if (status === 500)
        toast.error(error.response.data.errors);

    throw error.response;
});

const responseBody = (response) => response.data;

const sleep = (ms) => (response) =>
    new Promise(resolve => setTimeout(() => resolve(response), ms));

const requests = {
    get: (url) => axios.get(url).then(sleep(1000)).then(responseBody),
    post: (url, body) => axios.post(url, body).then(responseBody),
    put: (url, body) => axios.put(url, body).then(sleep(1000)).then(responseBody),
    delete: (url) => axios.delete(url).then(sleep(1000)).then(responseBody),
};

const User = {
    login: (user)=> requests.get(`/users/login?Username=${user.username}&Password=${user.password}`),
    current: () => requests.get('/users/get-current'),
    getAll:() => requests.get('/users'),
    save:(userInfo) => requests.post('/users', userInfo),
    edit:(userId, userInfo) => requests.put(`/users/${userId}`, userInfo),
    getUser:(userId) => requests.get(`/users/${userId}`, userId),
    getToken:(userId) => requests.get(`/users/${userId}/token`, userId),
    sendForgotPassword:(username) => requests.post('/users/forgot-password', username),
    resetPassword:(username) => requests.post('/users/reset-password', username),
    removeUser:(userId) => requests.delete(`/users/${userId}`)
};

const Company = {
    getAll:() => requests.get('/companies'),
    get:(companyId) => requests.get(`/companies/${companyId}`, companyId),
    save:(company) => requests.post('/companies', company),
    edit:(companyId, company) => requests.put(`/companies/${companyId}`, company),
};

const Crif = {
    getLogs:(criteria) => requests.post('/crif/get-queries-made', criteria)
};

export default {
    User,
    Company,
    Crif
}